// @flow

import type { PendingIncomingPayment } from './types';
import { getGateway } from '@tectonics/prs/gateway';

export function getGatewayVoucherCode(incomingPayment: PendingIncomingPayment): ?string {
  const gateway = getGateway(incomingPayment);
  return gateway['voucher_code'];
}

export function getSafeGatewayVoucherCode(incomingPayment: PendingIncomingPayment): string {
  const code = getGatewayVoucherCode(incomingPayment);
  if (!code) {
    throw new Error('getSafeGatewayVoucherCode - there is no voucher code in the incoming payment');
  }
  return code;
}
